import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TotemWidget } from '../totem-widget';
import { ForecastWeatherData, WeatherService } from 'pg-lib/services/weather.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-totem-widget-destination',
    templateUrl: './totem-widget-destination.component.html',
    styleUrls: ['./totem-widget-destination.component.scss'],
    standalone: false
})
export class TotemWidgetDestinationComponent extends TotemWidget implements OnInit, OnChanges, OnDestroy {
    size:'md'|'lg' = 'lg'

    constructor(public elementRef:ElementRef, private weatherService:WeatherService) {
        super(elementRef);
    }

    @Input() date:string|Date
    @Input() location:string
    /** When false, date is still used for calendar/weather but countdown is hidden. */
    @Input() showCountdown = true;
    /** When false, hides the clock next to the calendar date. */
    @Input() showTime = true;

    displayCountdown: {
        days: number,
        hours: number,
        minutes: number
    } = null

    private _refreshInterval = null;
    private _weatherSubscription: Subscription = null;

    forecast:ForecastWeatherData = null;
    private _initialized = false;

    ngOnInit(): void {
        super.ngOnInit()
        this._initialized = true;
        this._applyDateAndWeather();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this._initialized) return;
        if (changes['date'] || changes['location'] || changes['showCountdown']) {
            this.reload();
        }
    }

    /** Re-fetch weather / countdown after location or date changes. */
    reload() {
        this._applyDateAndWeather();
    }

    private _applyDateAndWeather() {
        this.forecast = null;
        this.displayCountdown = null;
        clearInterval(this._refreshInterval);
        this._refreshInterval = null;
        this._weatherSubscription?.unsubscribe();
        this._weatherSubscription = null;

        if (this.location) {
            this._weatherSubscription = this.weatherService.getForecastWeather(this.location).subscribe((data) => {
                if (this.date == null) {
                    this.forecast = data[0];
                    return;
                }

                const target = new Date(this.date);
                const diff = target.getTime() - Date.now();
                const dayTime = 1000 * 60 * 60 * 24;

                // OpenWeather free forecast is ~5 days ahead; for past days use today.
                if (diff < dayTime * 5) {
                    const dayDiff = Math.max(0, Math.floor(diff / dayTime));
                    this.forecast = data[dayDiff] || data[0];
                }
            });
        }

        if (this.date != null && this.showCountdown !== false) {
            this._refreshDisplayCountdown();
            this._refreshInterval = setInterval(() => {
                this._refreshDisplayCountdown();
            }, 200);
        }
    }

    private _refreshDisplayCountdown() {
        if(this.date != null) {
            let _date = new Date(this.date)

            let _diff = _date.getTime() - Date.now();
            let _abs = Math.abs(_diff);
            let _sign = _diff < 0 ? -1 : 1;

            this.displayCountdown = {
                // Single leading minus on days only when past the date
                days: _sign * Math.floor(_abs / (1000 * 60 * 60 * 24)),
                hours: Math.floor(_abs / (1000 * 60 * 60)) % 24,
                minutes: Math.floor(_abs / (1000 * 60)) % 60,
            }
        }
    }

    getCurrentDate() {
        return this.date || new Date();
    }

    ngOnDestroy(): void {
        clearInterval(this._refreshInterval)
        this._weatherSubscription?.unsubscribe();

        super.ngOnDestroy()
    }

    getBackgroundImage() {
        if(this.forecast != null) {
            return 'url(' + this.forecast?.getImage() + ')'
        }
    }
}
